import autobind from 'autobind-decorator';
import { observable, computed, action, toJS } from 'mobx';
import VolleyballMatchRelativeRecordVsRecordModel from './vsRecord';

@autobind
class VolleyballMatchRelativeRecordModel {
  home;
  away;

  @observable
  vsRecord = [];

  @observable
  recentHomeRecord = [];

  @observable
  recentAwayRecord = [];

  @observable
  nextHomeRecord = [];

  @observable
  nextAwayRecord = [];

  @observable
  selectedRecentRecordTab = 'home';

  constructor(data) {
    this.vsRecord = data.vsRecord.map(
      (item) => new VolleyballMatchRelativeRecordVsRecordModel(item)
    );
    this.recentHomeRecord = data.recentHomeRecord.map(
      (item) => new VolleyballMatchRelativeRecordVsRecordModel(item)
    );
    this.recentAwayRecord = data.recentAwayRecord.map(
      (item) => new VolleyballMatchRelativeRecordVsRecordModel(item)
    );
    this.nextHomeRecord = data.nextHomeRecord.map(
      (item) => new VolleyballMatchRelativeRecordVsRecordModel(item)
    );
    this.nextAwayRecord = data.nextAwayRecord.map(
      (item) => new VolleyballMatchRelativeRecordVsRecordModel(item)
    );
  }

  /**********************************************************
   * computed
   **********************************************************/

  /**********************************************************
   * actions
   **********************************************************/
  @action
  onClickTab(tab) {
    this.selectedRecentRecordTab = tab;
  }
}

export default VolleyballMatchRelativeRecordModel;
